<template>
  <div>
    <section style="max-height: 80vh; overflow-y: scroll">
      <table class="table align-middle table-bordered table-hover">
        <thead class="table-primary">
          <tr>
            <th>Username</th>
            <th>Role</th>
            <th>Full Name</th>
            <th>Job Title</th>
            <th>Organization</th>
            <th>Active</th>
            <th>Date created</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="index">
            <td>
              <router-link
                :to="{
                  name: 'visitProfile',
                  params: { username: user.username },
                }"
                custom
                v-slot="{ navigate }"
              >
                <span
                  role="link"
                  class="btn btn-link"
                  title="Go to user's Profile"
                  @click="navigate"
                  aria-current="true"
                  @keypress.enter="navigate"
                >
                  {{ user.username }}
                </span>
              </router-link>
            </td>
            <td>
              <span v-if="user.roles == 'administrator'" class="text-danger"
                >Admain</span
              >
              <span v-else-if="user.roles == 'manager'" class="text-primary"
                >Practitioners</span
              >
              <span v-else-if="user.roles == 'guest'" class="text-body"
                >Youth</span
              >
            </td>
            <td class="text-body">{{ user.firstname }} {{ user.lastname }}</td>
            <td class="text-body">{{ user.jobtitle }}</td>
            <td class="text-body">{{ user.organization }}</td>
            <td class="text-body">
              <span v-if="user.activation == 'true'">Active</span>
              <span v-else>Blocked</span>
            </td>
            <td class="text-body">{{ user.created_at }}</td>
            <td class="text-body">
              <button
                @click="setCurrentUser(user)"
                data-bs-toggle="modal"
                data-bs-target="#updateUser"
                class="btn btn-link"
              >
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <nav aria-label="Page navigation text-end">
      <ul class="pagination" style="justify-content: flex-end">
        <li class="page-item">
          <button
            v-if="lastindexPost >= perPage"
            class="btn page-link"
            @click="loadUsers(false)"
          >
            Previous
          </button>
          <button v-else class="btn page-link disabled" disabled>
            Previous
          </button>
        </li>

        <li v-for="i in countOfPages" :key="i" class="page-item">
          <span
            class="page-link"
            v-bind:class="currentPage == i ? 'text-primary' : false"
            >{{ i }}</span
          >
        </li>

        <li class="page-item">
          <button
            v-if="countOfPages > currentPage"
            @click="loadUsers(true)"
            class="btn page-link"
          >
            Next
          </button>
          <button v-else class="btn page-link disabled" disabled>Next</button>
        </li>
      </ul>
    </nav>
    <div
      class="modal fade"
      id="updateUser"
      tabindex="-1"
      aria-labelledby="updateUserLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div v-if="currnetUser" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="updateUserLabel">
              {{ currnetUser.name }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div>
              <div class="mb-3">
                <label for="roles" class="form-label">Roles</label>
                <select
                  class="form-select"
                  v-model="roles"
                  aria-label="Default select example"
                >
                  <option value="manager">Practitioners</option>
                  <option value="guest">Youth</option>
                </select>
              </div>
              <div class="mb-3">
                <label for="activation" class="form-label">Activation</label>
                <select
                  class="form-select"
                  v-model="activation"
                  aria-label="Default select example"
                >
                  <option value="true">Activation</option>
                  <option value="false">Block</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              <span @click="updateUser">Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminMembers",

  data() {
    return {
      users: [],
      roles: "",
      activation: "",
      lastindexPost: 0,
      currentPage: 1,
      perPage: 100,
      countOfPages: 0,
      currnetUser: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadUsers(null);
    });
  },
  methods: {
    loadUsers(directive) {
      if (directive != null) {
        if (directive) {
          this.lastindexPost += this.perPage;
          this.currentPage++;
        } else {
          this.lastindexPost -= this.perPage;
          this.currentPage--;
        }
      }

      this.$store.state.modules.api
        .getAllUsers(
          JSON.parse(localStorage.account).token,
          this.lastindexPost,
          this.perPage
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.users = resp.data.users;
            this.countOfPages = resp.data.countOfPages;
          } else {
            this.users = undefined;
          }
        })
        .catch((err) => {
          this.users = undefined;
        });
    },

    setCurrentUser(user) {
      this.currnetUser = user;
      this.roles = user.roles;
      this.activation = user.activation;
    },

    updateUser() {
      console.log(this.activation);

      this.$store.state.modules.api
        .updateUser(
          {
            uid: this.currnetUser.uid,
            roles: this.roles,
            activation: this.activation,
          },
          JSON.parse(localStorage.account).token
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                message: "success deleted Post",
              },
              2500
            );
            this.loadUsers(null);
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "warning Post",
              },
              2500
            );
          }
        });
    },
  },
};
</script>
